module.exports = __webpack_public_path__ + "img/icon_box_3_4.18d9e64b.png";